var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg24PxVideoSoundOff = function Svg24PxVideoSoundOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5 6 9H2v6h4l5 4zM23 9l-6 6M17 9l6 6"
  }))));
};
export default Svg24PxVideoSoundOff;